import dayjs from 'dayjs';

export const returnTotalUnitCompletionOfTaskFromChildren = (childTasks, assignmentStatsMap) => {
  const getTaskHours = (task) => {
    if (task.estimatedHours) {
      return Number(task.estimatedHours);
    }
    const days = dayjs(task.plannedEndDate).diff(dayjs(task.plannedStartDate), 'days') + 1;
    return days * 8;
  };

  const totalHours = childTasks.reduce((sum, child) => {
    return sum + getTaskHours(child);
  }, 0);

  const totalCompletion = childTasks.reduce((total, child) => {
    const childHours = getTaskHours(child);
    const weightRatio = childHours / totalHours;

    const assignmentData = assignmentStatsMap[child.assignmentId];
    const totalUnitCount = assignmentData ? assignmentData.totalUnitCount : 0;
    const unitAmountGoal = assignmentData ? assignmentData.unitAmountGoal : 0;

    const childUnitCompletion = (unitAmountGoal && totalUnitCount)
      ? Math.min((totalUnitCount / unitAmountGoal) * 100, 100)
      : (Number(child.manualCompletionValue) || 0);

    const weightedCompletion = childUnitCompletion * weightRatio;
    return total + weightedCompletion;
  }, 0);

  return totalCompletion;
};
